export default (function (_ref) {
  var service = _ref.service,
      request = _ref.request,
      serviceForMock = _ref.serviceForMock,
      requestForMock = _ref.requestForMock,
      mock = _ref.mock,
      faker = _ref.faker,
      tools = _ref.tools;
  return {
    divisionList: function divisionList(data) {
      return request({
        url: '/division/list',
        method: 'get',
        data: data
      });
    },
    divisionSave: function divisionSave(data) {
      return request({
        url: '/division/save',
        method: 'post',
        data: data
      });
    },
    divisionDelete: function divisionDelete(data) {
      return request({
        url: '/division/delete',
        method: 'post',
        data: data
      });
    },
    rewardList: function rewardList(data) {
      return request({
        url: '/reward/list',
        method: 'get',
        data: data
      });
    },
    rewardSave: function rewardSave(data) {
      return request({
        url: '/reward/save',
        method: 'post',
        data: data
      });
    },
    rewardDelete: function rewardDelete(data) {
      return request({
        url: '/reward/delete',
        method: 'post',
        data: data
      });
    },
    rewardTierList: function rewardTierList(data) {
      return request({
        url: '/reward/tier/list',
        method: 'get',
        data: data
      });
    },
    rewardTierDelete: function rewardTierDelete(data) {
      return request({
        url: '/reward/tier/delete',
        method: 'post',
        data: data
      });
    },
    rewardTierAdd: function rewardTierAdd(data) {
      return request({
        url: '/reward/tier/add',
        method: 'post',
        data: data
      });
    },
    rewardTierUpdate: function rewardTierUpdate(data) {
      return request({
        url: '/reward/tier/update',
        method: 'post',
        data: data
      });
    },
    eventList: function eventList(data) {
      return request({
        url: '/event/list',
        method: 'get',
        data: data
      });
    },
    eventSave: function eventSave(data) {
      return request({
        url: '/event/save',
        method: 'post',
        data: data
      });
    },
    eventDelete: function eventDelete(data) {
      return request({
        url: '/event/delete',
        method: 'post',
        data: data
      });
    },
    codeGenerate: function codeGenerate(data) {
      return request({
        url: '/activation-code/generate',
        method: 'post',
        data: data
      });
    },
    activationCodeList: function activationCodeList(data) {
      return request({
        url: '/activation-code/list',
        method: 'get',
        data: data
      });
    },
    activationCodeDelete: function activationCodeDelete(data) {
      return request({
        url: '/activation-code/delete',
        method: 'post',
        data: data
      });
    },
    eventParticipantList: function eventParticipantList(data) {
      return request({
        url: '/event-participant/list',
        method: 'get',
        data: data
      });
    },
    eventParticipantVip: function eventParticipantVip(data) {
      return request({
        url: '/event-participant/vip',
        method: 'get',
        data: data
      });
    },
    evenParticipantAdd: function evenParticipantAdd(data) {
      return request({
        url: '/event-participant/add',
        method: 'post',
        data: data
      });
    },
    evenParticipantDelete: function evenParticipantDelete(data) {
      return request({
        url: '/event-participant/delete',
        method: 'post',
        data: data
      });
    },
    designatedWinnerList: function designatedWinnerList(data) {
      return request({
        url: '/designated-winner/list',
        method: 'get',
        data: data
      });
    },
    designatedWinnerDelete: function designatedWinnerDelete(data) {
      return request({
        url: '/designated-winner/delete',
        method: 'post',
        data: data
      });
    },
    designatedWinnerAdd: function designatedWinnerAdd(data) {
      return request({
        url: '/designated-winner/add',
        method: 'post',
        data: data
      });
    },
    scoreDetailList: function scoreDetailList(data) {
      return request({
        url: '/score-detail/list',
        method: 'get',
        data: data
      });
    },
    scoreDetailAdd: function scoreDetailAdd(data) {
      return request({
        url: '/score-detail/add',
        method: 'post',
        data: data
      });
    },
    scoreDetailUpdate: function scoreDetailUpdate(data) {
      return request({
        url: '/score-detail/update',
        method: 'post',
        data: data
      });
    },
    scoreDetailDelete: function scoreDetailDelete(data) {
      return request({
        url: '/score-detail/delete',
        method: 'post',
        data: data
      });
    },
    eventAwardList: function eventAwardList(data) {
      return request({
        url: '/event-award/list',
        method: 'get',
        data: data
      });
    },
    eventAwardAdd: function eventAwardAdd(data) {
      return request({
        url: '/event-award/add',
        method: 'post',
        data: data
      });
    },
    eventAwardUpdate: function eventAwardUpdate(data) {
      return request({
        url: '/event-award/update',
        method: 'post',
        data: data
      });
    },
    eventAwardDelete: function eventAwardDelete(data) {
      return request({
        url: '/event-award/delete',
        method: 'post',
        data: data
      });
    },
    ranking: function ranking(data) {
      return request({
        url: '/ranking',
        method: 'get',
        data: data
      });
    },
    verControlList: function verControlList(data) {
      return request({
        url: '/ver-control/list',
        method: 'get',
        data: data
      });
    },
    verControlStore: function verControlStore(data) {
      return request({
        url: '/ver-control/store',
        method: 'post',
        data: data
      });
    },
    verControlUpdate: function verControlUpdate(data) {
      return request({
        url: '/ver-control/update',
        method: 'post',
        data: data
      });
    },
    verControlDelete: function verControlDelete(data) {
      return request({
        url: '/ver-control/delete',
        method: 'post',
        data: data
      });
    },
    eventEnd: function eventEnd(data) {
      return request({
        url: '/event/end',
        method: 'post',
        data: data
      });
    },
    divisionStudents: function divisionStudents(data) {
      return request({
        url: '/division/students',
        method: 'get',
        data: data
      });
    },
    serverList: function serverList(data) {
      return request({
        url: '/server/list',
        method: 'get',
        data: data
      });
    },
    serverSave: function serverSave(data) {
      return request({
        url: '/server/save',
        method: 'post',
        data: data
      });
    },
    serverDelete: function serverDelete(data) {
      return request({
        url: '/server/delete',
        method: 'post',
        data: data
      });
    },
    serverStudents: function serverStudents(data) {
      return request({
        url: '/server/students',
        method: 'get',
        data: data
      });
    }
  };
});